/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Receiver_LockedInputs */

const vi_carrier_form_receiver_locked = /** @type {(inputs: Carrier_Form_Receiver_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã thanh toán hoặc đang giao nên không sửa được người nhận tại đây.`)
};

/**

* @param {Carrier_Form_Receiver_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_receiver_locked = /** @type {((inputs?: Carrier_Form_Receiver_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Receiver_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_receiver_locked(inputs)
});